/*global Daon */
/*eslint no-undef: "error"*/

import { Component } from "react";
import { connect } from "react-redux";
import { instanceOf } from "prop-types";

import {
  createFaceCaptureInstance,
  setIsFaceWasmLoaded,
} from "logic/actions/faceCapture";

import { go } from "logic/actions/navigation";
import { PAGE_SESSION_EXPIRED } from "logic/enums/pages";
import {
  CAPTURE_HEIGHT,
  CAPTURE_INTERVAL,
  CAPTURE_WIDTH,
} from "logic/enums/faceCapture";
import {
  createDocumentCaptureInstance,
  setIsDocumentWasmLoaded,
} from "logic/actions/documentCapture";

const FACE_CAPTURE_PLUS_SCRIPT_ID = "daon-face-capture-plus-script";

export class WasmDependenciesLoader extends Component {
  state = {
    isFaceCaptureInstanceCreated: false,
    numberOfDFQInvocations: 0,
    isDocumentCaptureInstanceCreated: false,
    numberOfIDCInvocations: 0,
  };

  static getDerivedStateFromProps(props, state) {
    let update = {};
    if (!!props.FaceCaptureInstance !== state.isFaceCaptureInstanceCreated) {
      update.isFaceCaptureInstanceCreated = true;
    }

    if (!!props.docCaptureInstance !== state.isDocumentCaptureInstanceCreated) {
      update.isDocumentCaptureInstanceCreated = true;
    }
    return update;
  }
  //#TODO  MOVE ceate faceCaptureInstance to FaceCaptureUI
  componentDidMount() {
    this.initializeFaceCaptureInstance();

    /*
    if (!this.props.docCaptureInstance) {
      let resolution = {
        width: this.props.width ? parseInt(this.props.width) : 1920,
        height: this.props.height ? parseInt(this.props.height) : 1080
      }
      if (isIOS(navigator.userAgent)) {
        resolution = {
          width: 1280,
          height: 720,
          upscaledWidth: this.props.width ? parseInt(this.props.width) : 2816,
          upscaledHeight: this.props.height ? parseInt(this.props.height) : 1584,
        }
      }
      
      this.props.createDocumentCaptureInstance({
        width: resolution.width,
        height: resolution.height,
        upscaledWidth: resolution.upscaledWidth,
        upscaledHeight: resolution.upscaledHeight,
        captureType: "PORTRAIT",
        shouldSaveUnprocessed: this.props.fallbackToNative === "true" || this.props.fallbackToNative === true ? false : true,
      });
    }
    */
  }

  initializeFaceCaptureInstance = async () => {
    await this.ensureFaceCapturePlusAvailability(this.props.isFacePlusEnabled);

    if (!this.state.isFaceCaptureInstanceCreated) {
      this.props.createFaceCaptureInstance({
        isFacePlusEnabled: this.props.isFacePlusEnabled,
        faceConfig: {
          width: CAPTURE_WIDTH,
          height: CAPTURE_HEIGHT,
          imageFormat: this.props.face?.options?.imageType ?? "image/png",
          compressionRate: this.props.face?.options?.compressionRate ?? 1,
          captureInterval: CAPTURE_INTERVAL,
          payloadSize: "small", 
          shouldCheckGyroscope: this.props.face?.options?.shouldCheckGyroscope
            ? this.props.face?.options?.shouldCheckGyroscope
            : "NONE",
        },
      });
    }
  };

  ensureFaceCapturePlusAvailability = (isFacePlusEnabled) => {
    if (!isFacePlusEnabled) {
      this.unloadFaceCapturePlus();
      return Promise.resolve(false);
    }

    if (typeof Daon !== "undefined" && typeof Daon.FaceCapturePlus === "function") {
      return Promise.resolve(true);
    }

    return this.loadFaceCapturePlusScript();
  };

  unloadFaceCapturePlus = () => {
    const script = document.getElementById(FACE_CAPTURE_PLUS_SCRIPT_ID);
    if (script) {
      script.remove();
    }

    if (typeof Daon !== "undefined" && Daon.FaceCapturePlus) {
      delete Daon.FaceCapturePlus;
    }
  };

  loadFaceCapturePlusScript = () => {
    return new Promise((resolve) => {
      const existingScript = document.getElementById(FACE_CAPTURE_PLUS_SCRIPT_ID);

      const onLoaded = () => {
        const isLoaded =
          typeof Daon !== "undefined" &&
          typeof Daon.FaceCapturePlus === "function";
        resolve(isLoaded);
      };

      const onError = () => {
        resolve(false);
      };

      if (existingScript) {
        existingScript.addEventListener("load", onLoaded, { once: true });
        existingScript.addEventListener("error", onError, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.id = FACE_CAPTURE_PLUS_SCRIPT_ID;
      script.src = "/Daon.FaceCapturePlus.min.js";
      script.async = true;
      script.addEventListener("load", onLoaded, { once: true });
      script.addEventListener("error", onError, { once: true });
      document.body.appendChild(script);
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isFaceCaptureInstanceCreated !==
      this.state.isFaceCaptureInstanceCreated
    )
      this.loadFaceQualityModule();
    /*
  if (
    prevState.isDocumentCaptureInstanceCreated !==
    this.state.isDocumentCaptureInstanceCreated
  )
    this.loadDocumentCaptureModule();
*/
  }

  getDocumentWasmConfig = (onIDModuleInited) => {
    const idCaptureBaseUrl = window.location.origin;
    const shouldSaveUnprocessed = false;
    return {
      idCaptureBaseUrl,
      urlIDDetectorWasm: idCaptureBaseUrl + "/DaonIDCapture.wasm",
      shouldSaveUnprocessed,
      allowNonContinuouslyFrames: false,
      onIDModuleInited,
    };
  };

  loadDocumentCaptureModule() {
    if (!this.props.docCaptureInstance?.loadWasmModules) {
      return;
    }

    if (this.state.numberOfIDCInvocations < 20) {
      const onIDModuleInited = ({ isLoaded, error }) => {
        if (isLoaded) this.props.setIsDocumentWasmLoaded(true);
        if (error) {
          setTimeout(() => {
            this.loadDocumentCaptureModule();
          }, 5000);
          console.log(error);
        }
      };
      const wasmConfig = this.getDocumentWasmConfig(onIDModuleInited);

      try {
        this.props.docCaptureInstance.loadWasmModules(wasmConfig);
      } catch (err) {
        this.props.docCaptureInstance.loadWasmModules({
          idCaptureBaseUrl: wasmConfig.idCaptureBaseUrl,
          shouldSaveUnprocessed: wasmConfig.shouldSaveUnprocessed,
          allowNonContinuouslyFrames: wasmConfig.allowNonContinuouslyFrames,
          onIDModuleInited,
        });
      }

    } else {
      this.props.go(PAGE_SESSION_EXPIRED);
    }

    this.setState({
      numberOfIDCInvocations: this.state.numberOfIDCInvocations + 1,
    });
  }

  loadFaceQualityModule() {
    if (this.state.numberOfDFQInvocations < 20) {
      this.props.FaceCaptureInstance.loadDFQModule({
        urlFaceDetectorWasm: window.location.origin + "/DaonFaceQuality.wasm",
        onFaceModuleLoaded: ({ isLoaded, error }) => {
          if (isLoaded) this.props.setIsFaceWasmLoaded(true);
          if (error) {
            setTimeout(() => {
              this.loadFaceQualityModule();
            }, 5000);
            console.log(error);
          }
        },
        onIdLiveCameraStopped: () => {
          this.props.FaceCaptureInstance.stopCamera();
        }
      });
    } else {
      this.props.go(PAGE_SESSION_EXPIRED);
    }

    this.setState({
      numberOfDFQInvocations: this.state.numberOfDFQInvocations + 1,
    });
  }

  render() {
    return null;
  }
}

export default connect(
  (state) => {
    return {
      ...state.configuration.extraConfig?.featureFlags,
      ...state.livenessTest,
      ...state.faceCapture,
      ...state.documentCapture,
      ...state.configuration.extraConfig.steps,
      ...state.configuration.extraConfig.steps?.face?.options,
      ...{
        fallbackToNative:
          state.configuration.extraConfig.steps?.document?.options
            ?.fallbackToNative,
      },
      ...{
        documentQualityHostname: state.configuration.documentQualityHostname,
      },
      width:
        state.configuration.extraConfig.steps?.document?.options?.width ||
        state.configuration.extraConfig?.featureFlags?.width,
      height:
        state.configuration.extraConfig.steps?.document?.options?.height ||
        state.configuration.extraConfig?.featureFlags?.height,
    };
  },
  {
    createFaceCaptureInstance,
    createDocumentCaptureInstance,
    go,
    setIsFaceWasmLoaded,
    setIsDocumentWasmLoaded,
  }
)(WasmDependenciesLoader);
